module.exports = "/images/7f617a3d7c801834e7519e984f617142.svg";